import {Component, OnInit} from '@angular/core';
import { ApiService } from '@app/shared/services/api/api.service';
import { AuthService } from '@app/auth/services/auth/auth.service';
import { User } from '@app/auth/auth.models';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { timer, json } from 'd3';
import { Subscription } from 'rxjs';
import { interval } from 'rxjs';

@Component({
  selector: 'aar-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  aboutus : string = "";
  constructor(private api: ApiService) {

  }

  ngOnInit() {
     
    this.aboutus = this.api.getAboutUs();

  }
 
}
